import React, { Component, useState, useEffect } from "react";
import { PaginaCreacionLibre } from "../../Componentes/Compuestos/Paginas/PaginaCreacionLibre";
import { LVForm } from "../../Componentes/Basicos/LVForm";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { SimpleItem } from "devextreme-react/form";
import DateBox from 'devextreme-react/date-box';
import { WidgetComprasDelDia } from "../../Componentes/Dashboard/Widgets/WidgetComprasDelDia"
import { WidgetPedidosDelDia } from "../../Componentes/Dashboard/Widgets/WidgetPedidosDelDia"
import { WidgetVentasDelDia } from "../../Componentes/Dashboard/Widgets/WidgetVentasDelDia"
import { BarrasStandardVentasPorTipo } from "../../Componentes/Dashboard/Graficos/BarrasStandardVentasPorTipo";
import { BarrasStandardVentasPorSubTipo } from "../../Componentes/Dashboard/Graficos/BarrasStandardVentasPorSubTipo";
import { LineaMultiplesIVAComprasVentas } from "../../Componentes/Dashboard/Graficos/LineaMultiplesIVAComprasVentas";
import { LineaMultiplesPedidosVentas } from "../../Componentes/Dashboard/Graficos/LineaMultiplesPedidosVentas";
import ComboAbmEexPersonas from "../../Componentes/Compuestos/Combos/ComboAbmEexPersonas";
import ComboAbmZonEmpresas from "../../Componentes/Compuestos/Combos/ComboAbmZonEmpresas";
import ComboAbmZonPlantas from "../../Componentes/Compuestos/Combos/ComboAbmZonPlantas";
import { NumberBox } from "devextreme-react";
import { WidgetReservasDelDia } from "../../Componentes/Dashboard/Widgets/WidgetReservasDelDia";
import { WidgetReservasResumen } from "../../Componentes/Dashboard/Widgets/WidgetReservasResumen";
import { WidgetVentasDelDiaPorFormaDePago } from "../../Componentes/Dashboard/Widgets/WidgetVentasDelDiaPorFormaDePago";
import { WidgetVentasDelDiaPorFormaDePagoPorTerminalAbierta } from "../../Componentes/Dashboard/Widgets/WidgetVentasDelDiaPorFormaDePagoPorTerminalAbierta";
import { useNavigate } from "react-router-dom";
import { function_AsignacionDeTerminal, function_VerificacionDeCompaniaAutorizada } from "../../funciones/Varios";
import { function_ABM_ZON_Plantas_Leer } from "neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Plantas";
import { function_ABM_ZON_Empresas_Leer } from "neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Empresas";
import { function_ABM_EEX_Personas_Leer, function_ABM_EEX_Personas_ModificarPassword } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Personas";

export const DashBoardPrincipal = () => {
  const navigate = useNavigate();
  const [fecha, setFecha] = useState(new Date());
  const [esAdmin, setEsAdmin] = useState(false);
  const [idPersona, setIdPersona] = useState(localStorage.getItem("IdPersona"));
  const [terminal, setTerminal] = useState(localStorage.getItem("Terminal"));
  const [codigoEmpresa, setCodigoEmpresa] = useState(localStorage.getItem("CodigoEmpresa"));
  const [codigoPlanta, setCodigoPlanta] = useState(localStorage.getItem("CodigoPlanta"));
  const [permisos, setPermisos] = useState([]);
  const { Varios: { TratamientoDeVariableBoolean } } = require('neftis7_apicaller');
  const { TODOS_Dashboard: { function_TODOS_Dashboard_Permisos_ListarPorPersona } } = require('neftis7_apicaller');
  const [widgetKey, setWidgetKey] = useState(0);

  const handleFechaChange = (e) => {
    setFecha(e.value)
  };

  const handleIdPersona = async (e) => {
    if (e.value && e.value > 0) {
      localStorage.setItem("IdPersona", e.value);
      setIdPersona(e.value)
      setWidgetKey((prevKey) => prevKey + 1); // Actualiza la "key" para actualizar widgets
    }

    //Lo saco asi si soy admin no me saca los selectores de simulacion
    /*
    const Persona = await function_ABM_EEX_Personas_Leer(idPersona);
    setEsAdmin(Persona.data[0].Admin)
    */
  };

  const handleCodigoEmpresa = async (e) => {
    if (e.value && e.value !== "") {
      localStorage.setItem("CodigoEmpresa", e.value);
      const resultEmpresa = await function_ABM_ZON_Empresas_Leer(e.value)
      localStorage.setItem("DescripcionEmpresa", resultEmpresa.data[0].Descripcion);
      setCodigoEmpresa(e.value)
      setWidgetKey((prevKey) => prevKey + 1); // Actualiza la "key" para actualizar widgets
    }
  };

  const handleCodigoPlanta = async (e) => {
    if (e.value && e.value !== "") {
      localStorage.setItem("CodigoPlanta", e.value);
      const resultPlanta = await function_ABM_ZON_Plantas_Leer(e.value)
      localStorage.setItem("DescripcionPlanta", resultPlanta.data[0].Descripcion);
      setCodigoPlanta(e.value)

      localStorage.setItem("CodigoEmpresa", resultPlanta.data[0].CodigoEmpresa);
      const resultEmpresa = await function_ABM_ZON_Empresas_Leer(resultPlanta.data[0].CodigoEmpresa)
      localStorage.setItem("DescripcionEmpresa", resultEmpresa.data[0].Descripcion);
      setCodigoEmpresa(resultPlanta.data[0].CodigoEmpresa)

      setWidgetKey((prevKey) => prevKey + 1); // Actualiza la "key" para actualizar widgets
    }
  };

  const handleTerminal = async (e) => {
    if (parseInt(e.value) > 0) {
      setTerminal(e.value)
      setWidgetKey((prevKey) => prevKey + 1); // Actualiza la "key" para actualizar widgets
    }
  };

  const handleOnClick_CambioPassword = async (e) => {
    try {
      const nuevaPassword = prompt("Ingresá tu nueva contraseña:");
      if (!nuevaPassword) {
        alert("La contraseña no puede estar vacía.");
        return;
      }

      const confirmarPassword = prompt("Confirmá tu nueva contraseña:");
      if (nuevaPassword !== confirmarPassword) {
        alert("Las contraseñas no coinciden.");
        return;
      }

      await function_ABM_EEX_Personas_ModificarPassword(localStorage.getItem("IdPersona"), nuevaPassword)

      alert("Contraseña cambiada con éxito.");
    } catch (error) {
      alert(error)
    }
  };

  useEffect(() => {
    const functionAsinc = async () => {
      setEsAdmin(await TratamientoDeVariableBoolean(localStorage.getItem("EsAdmin")))

      const resultDashboardPermisos = await function_TODOS_Dashboard_Permisos_ListarPorPersona(idPersona)
      setPermisos(resultDashboardPermisos.data);

      if (!await function_VerificacionDeCompaniaAutorizada()) {
        navigate("/Login");
      }
    };

    functionAsinc();
  }, []);

  useEffect(() => {
    const functionAsinc = async () => {

      const terminalNueva = await function_AsignacionDeTerminal(terminal, false)
      if (terminal != terminalNueva) {
        setTerminal(terminalNueva)
      }
    };

    functionAsinc();
  }, [terminal]);

  return (
    <PaginaCreacionLibre
      Titulo={`PRINCIPAL`}
    >
      <LVForm>
        <SimpleItem>

          <table >
            <tbody>
              <tr>
                <td width={200}>
                  <DateBox
                    value={fecha}
                    onValueChanged={handleFechaChange}
                    displayFormat="dd-MM-yyyy"
                    width={140}
                  />
                </td>

                <td width={500}>
                  <ComboAbmZonEmpresas value={codigoEmpresa} onValueChanged={handleCodigoEmpresa} visible={esAdmin} />
                </td>

                <td width={500}>
                  <ComboAbmZonPlantas value={codigoPlanta} onValueChanged={handleCodigoPlanta} visible={esAdmin} />
                </td>

                <td width={100}>
                  <NumberBox value={terminal} onValueChanged={handleTerminal} visible={esAdmin} />
                </td>

                <td width={500}>
                  <ComboAbmEexPersonas value={idPersona} onValueChanged={handleIdPersona} visible={false} />
                </td>

                <td width={100}>
                  <LVButtonAccion Texto={"PERMISOS"}
                    onClick={() => navigate(`/Permisos`)} visible={esAdmin} />
                </td>

                <td width={20}>

                </td>

                <td width={100}>
                  <LVButtonAccion Texto={"PARAMETROS"}
                    onClick={() => navigate(`/Parametros`)} visible={esAdmin} />
                </td>

                <td width={20}>
                </td>

                <td width={100}>
                  <LVButtonAccion Texto={"ASISTENCIA EN LINEA - OPERADORES"}
                    onClick={() => navigate(`/AsistenciaEnLinea_Operadores`)} />
                </td>

                <td width={20}>

                </td>

                <td width={100}>
                  <LVButtonAccion Texto={"CAMBIO CONTRASEÑA"}
                    onClick={handleOnClick_CambioPassword} />
                </td>
              </tr>
            </tbody>
          </table>
        </SimpleItem>

        <SimpleItem>
          {permisos && permisos.length > 0 && permisos.some(item => item.Descripcion === "WidgetComprasDelDia") && <WidgetComprasDelDia Fecha={fecha} WidgetKey={widgetKey} />}
          {permisos && permisos.length > 0 && permisos.some(item => item.Descripcion === "WidgetPedidosDelDia") && <WidgetPedidosDelDia Fecha={fecha} WidgetKey={widgetKey} />}
          {permisos && permisos.length > 0 && permisos.some(item => item.Descripcion === "WidgetVentasDelDia") && <WidgetVentasDelDia Fecha={fecha} WidgetKey={widgetKey} />}
          {permisos && permisos.length > 0 && permisos.some(item => item.Descripcion === "WidgetReservasDelDia") && <WidgetReservasDelDia Fecha={fecha} WidgetKey={widgetKey} />}
        </SimpleItem>
        <SimpleItem>
          {permisos && permisos.length > 0 && permisos.some(item => item.Descripcion === "WidgetReservasResumen") && <WidgetReservasResumen Fecha={fecha} WidgetKey={widgetKey} />}
          {permisos && permisos.length > 0 && permisos.some(item => item.Descripcion === "WidgetVentasDelDiaPorFormaDePago") && <WidgetVentasDelDiaPorFormaDePago Fecha={fecha} WidgetKey={widgetKey} />}
          {permisos && permisos.length > 0 && permisos.some(item => item.Descripcion === "WidgetVentasDelDiaPorFormaDePagoPorTerminalAbierta") && <WidgetVentasDelDiaPorFormaDePagoPorTerminalAbierta Fecha={fecha} WidgetKey={widgetKey} />}
        </SimpleItem>
        <SimpleItem>
          {permisos && permisos.length > 0 && permisos.some(item => item.Descripcion === "BarrasStandardVentasPorTipo") && <BarrasStandardVentasPorTipo Fecha={fecha} WidgetKey={widgetKey} />}
          {permisos && permisos.length > 0 && permisos.some(item => item.Descripcion === "BarrasStandardVentasPorSubTipo") && <BarrasStandardVentasPorSubTipo Fecha={fecha} WidgetKey={widgetKey} />}
        </SimpleItem>
        <SimpleItem>
          {permisos && permisos.length > 0 && permisos.some(item => item.Descripcion === "LineaMultiplesPedidosVentas") && <LineaMultiplesPedidosVentas Fecha={fecha} WidgetKey={widgetKey} />}
          {permisos && permisos.length > 0 && permisos.some(item => item.Descripcion === "LineaMultiplesIVAComprasVentas") && <LineaMultiplesIVAComprasVentas Fecha={fecha} WidgetKey={widgetKey} />}
        </SimpleItem>
      </LVForm>
    </PaginaCreacionLibre >
  );
}